import { JSX, useEffect } from "react";
import { NewPatientClaimsEnum } from "@app/projects/servicing-provider/";
import { getNewPatientClaimsDefinitions } from "@app/projects/servicing-provider/ServicingProviderHelpers";
import MultiselectDropdown from "@app/shared/checkbox-dropdown/MultiselectDropdown";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";

interface NewPatientClaimsProps {
  mappedValues: DropdownItem<NewPatientClaimsEnum>[];
  selectedValues: DropdownItem<NewPatientClaimsEnum>[];
  setSelectedValues: (selectedValues: DropdownItem<NewPatientClaimsEnum>[]) => void;
  testId: string;
  title: string;
  disabled?: boolean;
}

const NewPatientClaimsFilter = (props: NewPatientClaimsProps): JSX.Element => {
  useEffect(() => {
    props.setSelectedValues(props.mappedValues);
  }, []);

  return (
    <MultiselectDropdown
      containerClassName="d-block"
      customSelectInputText={props.selectedValues.length === props.mappedValues.length ? "All" : null}
      disabled={props.disabled}
      items={props.mappedValues}
      onSelectionChanged={(selectedValues: DropdownItem<NewPatientClaimsEnum>[]) => { props.setSelectedValues(selectedValues) }}
      label={props.title}
      selectedItems={props.selectedValues}
      testId={props.testId}
      validationTooltipContent={getNewPatientClaimsDefinitions()}
    />
  )
}

export default NewPatientClaimsFilter;
